export default () => ({
  step: 1,
  completedStep: 0,
  email: '',
})
